import Box from "@mui/material/Box";
import type { PropsWithChildren } from "react";

import { LatestPostsCarousel, Logo } from "@/components";

export function AuthLayout({ children }: PropsWithChildren) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                minHeight: "100vh",
                backgroundColor: "background.paper",
            }}
        >
            <Box
                sx={{
                    px: { xs: 3, md: 8 },
                    py: 10,
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "paper.default",
                    width: "100%",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                {children}
            </Box>

            <Box
                sx={{
                    display: { xs: "none", md: "block" },
                    position: "relative",
                }}
            >
                <Box sx={{ position: "absolute", right: 50, top: 50 }}>
                    <Logo height={70.9} />
                </Box>
                <Box
                    sx={{
                        height: "100%",
                        minHeight: "100vh",
                        background: (theme) =>
                            `linear-gradient(196.01deg, ${theme.palette.background.paper} 27.03%, ${theme.palette.primary.main} 92.37%)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box sx={{ textAlign: "center", color: "white" }}>
                        <LatestPostsCarousel />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
